var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#F9834C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C11.725 18.5 11.4896 18.3922 11.2938 18.1765C11.0979 17.9609 11 17.7017 11 17.3988C11 17.096 11.0979 16.8368 11.2938 16.6211C11.4896 16.4055 11.725 16.2977 12 16.2977C12.275 16.2977 12.5104 16.4055 12.7062 16.6211C12.9021 16.8368 13 17.096 13 17.3988C13 17.7017 12.9021 17.9609 12.7062 18.1765C12.5104 18.3922 12.275 18.5 12 18.5ZM11.0898 14.9V6.5H12.9102V14.9H11.0898Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleFilled);
export default __webpack_public_path__ + "static/media/WarningCircleFilled.97dfcce65fce8cd0394b5677c59c875b.svg";
export { ForwardRef as ReactComponent };